<template>
  <div class="contain">
    <div class="topTitle flex">
      <span class="preview">猜你喜欢统计</span>
      <div class="show_time">
        <span>
          <span v-if="!dayNum">统计时间 {{ queryEndTime }} &nbsp</span>
          <span v-else
            >统计时间 {{ queryStartTime }}~ {{ queryEndTime }} &nbsp</span
          >
        </span>
        <span>
          <span v-if="!dayNum">&nbsp 对比周期 {{ pkTime2 }}</span>
          <span v-else>&nbsp 对比周期 {{ pkTime1 }}~{{ pkTime2 }}</span>
        </span>
      </div>
      <el-select
        v-model="region"
        placeholder="请选择商户"
        style="width: 200px"
        @change="MerchSelete"
      >
        <el-option
          v-for="(item, index) in seleteAppList"
          :key="index"
          :label="item.nickName"
          :value="index"
        ></el-option>
      </el-select>
    </div>

    <div class="seleData flex">
      <div class="seleflow flex">
        <div class="flex trend">统计概览</div>
        <div class="flex">
          <div style="margin-right: 10px">
            <el-button
              type="primary"
              :class="timeTable == 1 ? 'button-activy' : 'not-button-activy'"
              @click="oldData(1)"
              >昨天</el-button
            >
          </div>
          <div style="margin-right: 10px">
            <el-button
              type="primary"
              :class="timeTable == 2 ? 'button-activy' : 'not-button-activy'"
              @click="oldData(7)"
              >过去7天</el-button
            >
          </div>
          <div style="margin-right: 20px">
            <el-button
              type="primary"
              :class="timeTable == 3 ? 'button-activy' : 'not-button-activy'"
              @click="oldData(30)"
              >过去30天</el-button
            >
          </div>
          <div class="seleteTime">
            <el-date-picker
              v-model="value1"
              @change="change"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
          <el-button type="primary">导出</el-button>
        </div>
      </div>
      <div class="slide flex">
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616829047435-60c03891-56a8-42d2.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">商品曝光数
              <el-tooltip
                class="tooltip"
                effect="light"
                content="统计时间内，商品通过猜你喜欢的展现次数"
                placement="top"
            >
              <i class="el-icon-question" style="font-size: 16px"></i>
            </el-tooltip>
            </span>
            <span class="newNum">{{ visualData.exposureCount }}</span>
            <div class="capita flex">
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较对比周期</span>
                  <span class="num"
                    >{{ visualData.comparisonExposureCount }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616834220567-2ff01991-d3d6-424d.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">点击数
              <el-tooltip
                  class="tooltip"
                  effect="light"
                  content="统计时间内，用户通过猜你喜欢点击商品的次数"
                  placement="top"
              >
                <i class="el-icon-question" style="font-size: 16px"></i>
              </el-tooltip>
            </span>
            <span class="newNum">{{ visualData.clickCount }}</span>
            <div class="capita flex">
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较对比周期</span>
                  <span class="num"
                    >{{ visualData.comparisonClickCount }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616834257511-403e3939-94a4-4072.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">曝光-点击率
              <el-tooltip
                  class="tooltip"
                  effect="light"
                  content="统计时间内，点击数/曝光数"
                  placement="top"
              >
                <i class="el-icon-question" style="font-size: 16px"></i>
              </el-tooltip>
            </span>
            <span class="newNum">{{ visualData.exposureClickCount }}%</span>
            <div class="capita flex">
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较对比周期</span>
                  <span class="num"
                    >{{ visualData.comparisonExposureClickCount }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616835890562-b4d050bd-6a7e-4dcc.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">支付金额
              <el-tooltip
                  class="tooltip"
                  effect="light"
                  content="统计时间内，通过猜你喜欢的支付金额"
                  placement="top"
              >
                <i class="el-icon-question" style="font-size: 16px"></i>
              </el-tooltip>
            </span>
            <span class="newNum">{{ ToFixed(visualData.payMoney, 2) }}</span>
            <div class="capita flex">
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较对比周期</span>
                  <span class="num">{{ visualData.comparisonPayMoney }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newUser flex item-center">
          <img
            src="https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-27/1616835890562-b4d050bd-6a7e-4dcc.png"
            alt=""
          />
          <div class="user flex">
            <span class="newUsers">支付订单数
              <el-tooltip
                  class="tooltip"
                  effect="light"
                  content="统计时间内，通过猜你喜欢的支付订单数"
                  placement="top"
              >
                <i class="el-icon-question" style="font-size: 16px"></i>
              </el-tooltip>
            </span>
            <span class="newNum">{{ visualData.payOrderCount }}</span>
            <div class="capita flex">
              <div class="boaFence flex">
                <div class="time flex">
                  <span class="yesterday">较对比周期</span>
                  <span class="num"
                    >{{ visualData.comparisonPayOrderCount }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="trend">
      <ve-line :data="chartData"></ve-line>
    </div>

    <div class="tabForm">
      <div class="tabForm_top">
        <i class="tabForm_top_col"></i>
        <span class="tabForm_top_title">版位统计</span>
        <span class="tabForm_top_text"
          >统计猜你喜欢在商城中各个版块中的展示效果，每个版位列表项对应您的商城界面上的一个版块</span
        >
      </div>
      <el-table
        stripe
        border
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          prop="pathName"
          label="版位"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="exposureCount"
          label="商品曝光数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="clickCount"
          label="点击数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="exposureClickCount"
          label="曝光点击率"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.exposureClickCount }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="addCartCount"
          label="加购物车数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="payOrderCount"
          label="支付订单数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="exposurePayOrderCount"
          label="曝光-支付转化率"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.exposurePayOrderCount }}%
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
import { ToFixed } from "@/utils/utils";
export default {
  data() {
    return {
      timeTable: 1,
      region: "",
      value1: [],
      tableData: [],
      seleteAppList: [],
      timeQuantumType: "hour",
      dayNum: false,
      initiali: {},
      pkTime1: "",
      pkTime2: "",
      queryStartTime: "",
      queryEndTime: "",
      taday: "",
      yesterday: "", // 昨天
      visualData: {}, // 统计概览
      chartData: {
        columns: [
          "dateValue",
          "曝光商品",
          "点击数",
          "曝光-点击率",
          "支付金额",
          "支付订单数"
        ],
        rows: []
      },
      storeCode: "",
      busType: "",
      ToFixed
    };
  },
  components: {
    VeLine
  },
  created() {
    let curDate = new Date();
    let nowDate = curDate.getTime();
    let preDate = new Date(curDate.getTime() - 1 * 24 * 60 * 60 * 1000); //前一天
    let preDate2 = new Date(curDate.getTime() - 2 * 24 * 60 * 60 * 1000); //前一天
    this.queryStartTime = this.formatDateTime(preDate);
    this.queryEndTime = this.queryStartTime;
    this.yesterday = this.formatDateTime(preDate);
    this.taday = this.formatDateTime(new Date(curDate.getTime()));
    this.pkTime2 = this.formatDateTime(preDate2);

    if (this.$route.query.busType) {
      this.busType = this.$route.query.busType;
    }
    if (this.$route.query.storeCode) {
      this.storeCode = this.$route.query.storeCode;
    }
    this.value1 = [this.yesterday, this.yesterday];
    this.getSeleteWechat();
  },
  methods: {
    change(e) {
      if (e[0] == e[1]) {
        this.dayNum = false;
        this.yesterday = e[0];
        let t = this.getBeforeDate(1, e[0]);
        this.pkTime2 = t;
        this.timeQuantumType = "hour";
      } else {
        this.dayNum = true;
        this.queryStartTime = e[0];
        this.queryEndTime = e[1];
        let numDay = this.getDaysBetween(e[0], e[1]);
        this.pkTime1 = this.getBeforeDate(numDay + 1, e[0]);
        this.pkTime2 = this.getBeforeDate(1, e[0]);
        this.timeQuantumType = "date";
      }
      this.getStatistics();
      this.getEchartsList();
      this.getTableList();
    },
    // 头部获取用户
    async getSeleteWechat() {
      const { result } = await this.$store.dispatch("queryWechatSelete", {});
      this.seleteAppList = result;
      this.region = 0;
      let self = this;
      if (this.storeCode && this.busType) {
        this.seleteAppList.forEach(function(item, index) {
          if (
            item.miniProgramType == self.busType &&
            item.storeCode == self.storeCode
          ) {
            self.region = index;
          }
        });
      }
      this.initiali = result[this.region];
      this.getStatistics();
      this.getEchartsList();
      this.getTableList();
    },
    // 日历
    MerchSelete(e) {
      let index = e;
      this.initiali = this.seleteAppList[index];
      this.getEchartsList();
      this.getStatistics();
      this.getTableList();
    },
    oldData(time) {
      let curDate = new Date();
      let preDate1 = new Date(curDate.getTime() - 1 * 24 * 60 * 60 * 1000); //前1天
      let preDate2 = new Date(curDate.getTime() - 2 * 24 * 60 * 60 * 1000); //前2天
      let preDate7 = new Date(curDate.getTime() - 7 * 24 * 60 * 60 * 1000); //前7天
      let preDate8 = new Date(curDate.getTime() - 8 * 24 * 60 * 60 * 1000); //前8天
      let preDate15 = new Date(curDate.getTime() - 15 * 24 * 60 * 60 * 1000); //前14天
      let preDate30 = new Date(curDate.getTime() - 30 * 24 * 60 * 60 * 1000); //前30天
      let preDate31 = new Date(curDate.getTime() - 31 * 24 * 60 * 60 * 1000); //前30天
      let preDate61 = new Date(curDate.getTime() - 61 * 24 * 60 * 60 * 1000); //前61天
      this.queryEndTime = this.yesterday;
      if (time == 1) {
        this.dayNum = false;
        this.queryStartTime = this.formatDateTime(preDate1);
        this.pkTime2 = this.formatDateTime(preDate2);
        this.timeQuantumType = "hour";
        this.timeTable = 1;
        this.value1 = [this.queryEndTime, this.queryEndTime];
      }
      if (time == 7) {
        this.dayNum = true;
        this.queryStartTime = this.formatDateTime(preDate7);
        this.pkTime1 = this.formatDateTime(preDate15);
        this.pkTime2 = this.formatDateTime(preDate8);
        this.timeQuantumType = "date";
        this.timeTable = 2;
      }
      if (time == 30) {
        this.dayNum = true;
        this.queryStartTime = this.formatDateTime(preDate30);
        this.pkTime1 = this.formatDateTime(preDate61);
        this.pkTime2 = this.formatDateTime(preDate31);
        this.timeQuantumType = "date";
        this.timeTable = 3;
      }
      this.value1 = [this.queryStartTime, this.queryEndTime];
      this.getEchartsList();
      this.getStatistics();
      this.getTableList();
    },
    // 计算day差
    getDaysBetween(dateString1, dateString2) {
      var startDate = Date.parse(dateString1);
      var endDate = Date.parse(dateString2);
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      return days;
    },
    // 计算 指定的日期函数
    getBeforeDate(num, time) {
      let n = num;
      let d = "";
      if (time) {
        d = new Date(time);
      } else {
        d = new Date();
      }
      let year = d.getFullYear();
      let mon = d.getMonth() + 1;
      let day = d.getDate();
      if (day <= n) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() - n);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      let s =
        year +
        "-" +
        (mon < 10 ? "0" + mon : mon) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d;
    },
    //  获取统计数据
    async getStatistics() {
      const { result } = await this.$store.dispatch("createUrlGeneral", {
        timeQuantumType: this.timeQuantumType,
        queryStartTime: this.queryStartTime,
        queryEndTime: this.queryEndTime,
        storeCode: this.initiali.storeCode
      });
      if (result) {
        this.visualData = result;
      }
    },
    // 图表接口
    async getEchartsList() {
      const { result } = await this.$store.dispatch("getEcharts", {
        timeQuantumType: this.timeQuantumType,
        queryStartTime: this.queryStartTime,
        queryEndTime: this.queryEndTime,
        storeCode: this.initiali.storeCode
      });
      this.chartData.rows = result;
      let broLine = result;
      let list = [];
      broLine.forEach(item => {
        list.push({
          dateValue: item.timeQuantum,
          曝光商品: item.exposureCount,
          点击数: item.clickCount,
          点击率: item.exposureClickCount,
          支付金额: item.payMoney,
          支付订单数: item.payOrderCount
        });
      });
      console.log("list------", list);
      this.chartData.rows = list;
    },
    // 表格接口
    async getTableList() {
      let res = await this.$store.dispatch("getTableList", {
        timeQuantumType: this.timeQuantumType,
        queryStartTime: this.queryStartTime,
        queryEndTime: this.queryEndTime,
        storeCode: this.initiali.storeCode
      });
      this.tableData = res.result;
      console.log("表格接口----res", this.tableData);
    },
    // 查看
    handleClick(row) {
      console.log(row);
      console.log(this.initiali.storeCode);
      this.$router.push({
        name: "GuessLikeDetail",
        query: {
          row: JSON.stringify(row),
          storeCode: this.initiali.storeCode
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.contain {
  flex-direction: column;
  .topTitle {
    background: #fff;
    margin-bottom: 10px;
    padding: 20px;
    align-items: center;
    justify-content: space-between;
    // align-items: center;
    // border-bottom: 1px solid #e5e9f2;
    .preview {
      color: #222222;
      font-weight: 500;
      font-size: 26;
      width: 300px;
    }
    .show_time {
      font-size: 14px;
      flex: 1;
      margin-right: 50px;
      text-align: right;
      float: right;
    }
  }
  .tips {
    padding: 20px 20px;
    background: #ffffee;

    span {
      color: #222222;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .seleData {
    padding: 10px;
    flex-direction: column;
    // justify-content: flex-end;
    height: 232px;
    background: #ffffff;
    border-bottom: 10px;
    .seleflow {
      justify-content: space-between;
      .trend {
        height: 20px;
        border-left: 3px solid #e60669;
        padding: 0 5px;
        align-items: center;
      }
    }
    .slide {
      margin-top: 37px;
      margin-bottom: 10px;
      .newUser {
        width: 416px;
        height: 80px;
        padding: 20px 10px;
        box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
        img {
          width: 66px;
          height: 66px;
        }
        .user {
          flex-direction: column;
          margin-left: 20px;
          flex: 1;
          .newUsers {
            color: #222222;
            font-size: 14px;
            line-height: 2;
          }
          .newNum {
            color: #222222;
            font-size: 24px;
            font-weight: 600;
            margin: 5px;
            display: block;
          }
          .capita {
            justify-content: space-between;
            align-items: center;

            .boaFence {
              margin-right: 20px;
              .time {
                margin-right: 10px;
                .yesterday {
                  color: #222222;
                  font-size: 14px;
                }
                .num {
                  color: #222222;
                  font-size: 14px;
                  margin-left: 6px;
                }
              }
              .increase {
                span {
                  color: #222222;
                  font-size: 14px;
                }
              }
            }
          }

          .newNum {
            color: #222222;
            font-weight: 600;
            font-size: 24px;
          }
        }
        .decrease {
          align-items: flex-end;
        }
      }
    }
  }
  .trend {
    margin-top: 10px;
    padding: 10px 20px;
    background: #ffffff;
  }
  .tabForm {
    padding: 0 20px;
    background: #ffffff;
    .tabForm_top {
      width: 100%;
      height: 40px;
      .tabForm_top_col {
        height: 22px;
        width: 3px;
        background: red;
        display: inline-block;
      }
      .tabForm_top_title {
        font-size: 16px;
        display: inline-block;
        margin: 0 10px;
      }
      .tabForm_top_text {
        font-size: 14px;
        color: #999;
      }
    }
  }
  .button-activy {
    background-color: #e50065;
    border-color: #e50065;
  }

  .not-button-activy {
    background-color: white;
    border-color: #e50065;
    color: black;
  }

  // .translate {
  //   justify-content: space-between;
  //   align-items: center;
  //   padding: 10px;
  //   background: #f8f8f8;
  //   margin-top: 20px;
  //   .title {
  //     .pattern {
  //       display: block;
  //       width: 3px;
  //       height: 16px;
  //       background: #2a75ed;
  //       margin-right: 8px;
  //     }
  //   }
  // }

  // .timeProcess {
  //   justify-content: center;
  //   margin-top: 20px;
  //   .newUser {
  //     width: 200px;
  //     border: 1px solid #f2f2f2;
  //     padding: 15px;
  //     .describe {
  //       flex-direction: column;
  //       .new {
  //         margin-bottom: 6px;
  //         font-size: 14px;
  //       }
  //       .num {
  //         margin-bottom: 6px;
  //         font-size: 18px;
  //         font-weight: bold;
  //       }
  //       .days {
  //         margin-bottom: 6px;
  //         font-size: 14px;
  //         color: #aaaaaa;
  //       }
  //     }
  //   }
  // }
}
</style>
